import { render, staticRenderFns } from "./AdminUserSignUp.vue?vue&type=template&id=54708ac4&scoped=true"
import script from "./AdminUserSignUp.vue?vue&type=script&lang=js"
export * from "./AdminUserSignUp.vue?vue&type=script&lang=js"
import style0 from "./AdminUserSignUp.vue?vue&type=style&index=0&id=54708ac4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54708ac4",
  null
  
)

export default component.exports